module.exports = __webpack_public_path__ + "img/03_1.c408cb8e.png";